export const URL = '/v2/pms/accomodations/:accomId/media/batch_move/'

export type Req = {
  ids: number[]
  room_category: number | null
}

export type Resp = any
